import { isSupportedCountry, type CountryCode } from 'libphonenumber-js';

const FALLBACK_COUNTRY: CountryCode = 'DK';

/**
 * Best-effort guess of the user's country from their browser locale, used to
 * preselect a sensible default in the phone country picker. Reads the region
 * subtag out of `navigator.language` (e.g. `en-US` -> `US`), with no
 * permission prompt and no network call. Falls back to Denmark when the
 * locale doesn't resolve to a region libphonenumber-js recognizes.
 */
export function getDefaultCountryFromLocale(): CountryCode {
  const locale =
    typeof navigator !== 'undefined' && navigator.language
      ? navigator.language
      : Intl.DateTimeFormat().resolvedOptions().locale;

  if (!locale) return FALLBACK_COUNTRY;

  try {
    const region = new Intl.Locale(locale).maximize().region;
    if (region && isSupportedCountry(region)) {
      return region;
    }
  } catch {
    // Malformed locale string — fall through to the fallback below.
  }

  return FALLBACK_COUNTRY;
}
